import { OktaAuthOptions, AuthState, UserClaims, OktaAuth } from '@okta/okta-auth-js';

export const SCOPES: string[] = ['openid', 'profile', 'email', 'offline_access'];
export const LOGIN_CALLBACK_URI = '/implicit/callback';
export const LOGIN_REDIRECT_URI = `${window.location.origin}${process.env.PUBLIC_URL}${LOGIN_CALLBACK_URI}`;
export const POST_LOGOUT_REDIRECT_URI = `${window.location.origin}${process.env.PUBLIC_URL}`;

export type AuthConfig = {
  clientId: string,
  issuer: string
};

export const externalAuth = {
  clientId: '0oatknfar44Jr1BtV357',
  issuer: 'https://login.dotfoods.com/oauth2/default'
};

export const internalAuth = {
  clientId: '0oazkgvl52c47XsP00x7',
  issuer: 'https://dotfoods.okta.com/oauth2/default'
};

export const oktaConfig: OktaAuthOptions = {
  ...externalAuth,
  redirectUri: LOGIN_REDIRECT_URI,
  scopes: SCOPES,
  pkce: true,
  transformAuthState: async (oktaAuth: OktaAuth, authState: AuthState): Promise<AuthState> => {
    if (!authState.isAuthenticated) {
      return authState;
    }

    // extra requirement: user must have valid Okta SSO session if the user is online
    if (navigator.onLine) {
      const user: UserClaims | undefined = await oktaAuth.token.getUserInfo();
      authState.user = user;
      authState.isAuthenticated = !!user;
    }

    return authState;
  }
} as OktaAuthOptions;